import { render } from "./Login.vue?vue&type=template&id=3b1203c2&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=3b1203c2&lang=css"
import "./Login.vue?vue&type=style&index=1&id=3b1203c2&scoped=true&lang=css"

import exportComponent from "D:\\Shivani\\myProjects\\p2p_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1203c2"]])

export default __exports__